export default "__VITE_ASSET__BLu_k9lo__"